<template>
  <router-view></router-view>
</template>
<script>
export default {
    name: `Dictionary`,
    props: {

    },
    data() {
        return {
            title: `基础数据`
        }
    },
    computed: {

    },
    created() {
    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Index.vue